import { useUnifiedBilling } from '../store/global-billing'
import { isPlanEnded, resolveMeetingLimitRoute, type MeetingLimitRoute } from '../utils/billingUtils'

/** {@link resolveMeetingLimitRoute} against the live billing state. */
export function useMeetingLimitRoute(): MeetingLimitRoute {
  const { paywall, subscription } = useUnifiedBilling()
  return resolveMeetingLimitRoute({ plan: paywall.plan, planEnded: isPlanEnded(subscription) })
}
